import Intercom, { shutdown } from '@intercom/messenger-js-sdk';

import { INTERCOM_APP_ID } from '~/constants/intercom';

export const initIntercom = (name?: string, email?: string, hash?: string): void => {
  // Ensure clean re-init if needed
  if (window.Intercom) {
    shutdown();
  }

  Intercom({
    app_id: INTERCOM_APP_ID,
    hide_default_launcher: true,
    name,
    email,
    user_hash: hash,
  });
};
